import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const cancelManagerFromProjects = createAsyncThunk(
    "cancelManagerProject/cancel",
    async (projectId, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token"); // Adjust if you store auth differently
            const res = await axiosInstance.delete(
                `${BackendURL}/managerProjectRequested/cancel-manager/${projectId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.error || "Failed to cancel manager from project"
            );
        }
    }
);

export const cancelManagerFromProject = createAsyncThunk(
    "cancelManagerProject/cancel",
    async (projectId, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/manager-cancel-approved`,
                { projectid: projectId }
            );

            return res.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.error || "Failed to cancel manager from project"
            );
        }
    }
);


const cancelManagerProjectSlice = createSlice({
    name: "cancelManagerProject",
    initialState: {
        loading: false,
        success: false,
        error: null,
        message: null,
    },
    reducers: {
        resetCancelManagerState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.message = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(cancelManagerFromProject.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(cancelManagerFromProject.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || "Manager removed successfully";
            })
            .addCase(cancelManagerFromProject.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload || "Something went wrong";
            })

            .addCase(cancelManagerFromProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(cancelManagerFromProjects.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || "Manager removed successfully";
            })
            .addCase(cancelManagerFromProjects.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload || "Something went wrong";
            })
    },
});

export const { resetCancelManagerState } = cancelManagerProjectSlice.actions;
export default cancelManagerProjectSlice.reducer;
